import { Box, Card, Grid, Skeleton, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { useQuery } from '@tanstack/react-query';

import { selectPersonId, selectReplacedPersonId } from '@/store/user-process/user-selectors';

import { Support } from '@/widgets/Support';

import { servicesApi } from '@/shared/api/services.ts';
import { FOOD_SERVICE_URL } from '@/shared/constant/services.ts';
import IconHeadset from '@/shared/uikit/assets/icons/IconHeadset.svg?react';
import IconHeart from '@/shared/uikit/assets/icons/IconHeart.svg?react';
import IconPerson from '@/shared/uikit/assets/icons/IconPerson.svg?react';
import { BottomSheet } from '@/shared/uikit/components/bottomSheet';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

import { IconSoup } from '@tabler/icons-react';

import { UserProfile } from '../UserProfile';

import { useAppSelector } from '@/hooks';

export const WidgetsBoard = () => {
	const [openedProfile, { close: closeProfile, open: openProfile }] = useDisclosure(false);
	const [openedSupport, { close: closeSupport, open: openSupport }] = useDisclosure(false);

	const personId = useAppSelector(selectPersonId);
	const replacedPersonId = useAppSelector(selectReplacedPersonId);

	const { data: isAvailableFoodService = false, isPending: isAvailableFoodServicePending } =
		useQuery({
			queryKey: ['food_service'],
			queryFn: servicesApi.isAvailableFoodService,
		});

	return (
		<>
			<Box>
				<LayoutRow type="once">
					<Skeleton visible={isAvailableFoodServicePending}>
						<Grid gutter={8} grow>
							{isAvailableFoodService && (
								<Grid.Col span={4}>
									<Card
										radius={16}
										style={{
											padding: 12,
											height: 100,
											background: '#F5F4F2',
											justifyContent: 'space-between',
										}}
										onClick={() => window.open(FOOD_SERVICE_URL.value, '_blank')}
									>
										<Text fw={600}>Заказ еды</Text>

										<Box ta={'right'}>
											{/*<IconHeart color="rgb(176, 163, 142)" fontSize={27} />*/}
											<IconSoup color="rgb(176, 163, 142)" size={34} />
										</Box>
									</Card>
								</Grid.Col>
							)}
							<Grid.Col span={4}>
								<Card
									radius={16}
									style={{
										padding: 12,
										height: 100,
										background: '#F5F4F2',
										justifyContent: 'space-between',
									}}
									onClick={openSupport}
								>
									<Text fw={600}>Проблема</Text>

									<Box ta={'right'}>
										<IconHeadset />
									</Box>
								</Card>
							</Grid.Col>
							<Grid.Col span={4}>
								<Card
									radius={16}
									style={{
										padding: 12,
										height: 100,
										background: '#F5F4F2',
										justifyContent: 'space-between',
									}}
									onClick={openProfile}
								>
									<Stack gap={0}>
										<Text fw={600} unselectable="on">
											Профиль
										</Text>
										{personId !== replacedPersonId && (
											<Text c="red" size="sm" fw={500} unselectable="on">
												Пользователь замещён
											</Text>
										)}
									</Stack>

									<Box ta={'right'}>
										<IconPerson />
									</Box>
								</Card>
							</Grid.Col>
						</Grid>
					</Skeleton>
				</LayoutRow>
			</Box>

			<BottomSheet
				opened={openedProfile}
				onClose={closeProfile}
				title="Профиль"
				withBackButton={false}
				withCloseButton
			>
				<UserProfile />
			</BottomSheet>

			<BottomSheet
				opened={openedSupport}
				onClose={closeSupport}
				title="Проблема"
				withBackButton={false}
				withCloseButton
			>
				<Support />
			</BottomSheet>
		</>
	);
};
